import EntityContentItemMediaRepeaterItem from './EntityContentItemMediaRepeaterItem';

export default EntityContentItemMediaRepeaterItem;
